import { Button, Menu, MenuButton, MenuList } from '@airbus/components-react';
import { Chevrondown } from '@airbus/icons/react';
import styles from './GridHeader.module.css';
import { useLanguageContextAPI } from '../../context/LanguageContext';
import { cloneElement, Children } from 'react';

export default function GridHeaderAction(props) {
  const { t } = useLanguageContextAPI();
  if (!props.children) return null;

  const translatedActionsList = Children.map(props.children, (child) => {
    if (!child) return null;
    return cloneElement(child, {
      children: child.key
        ? t(`header_actions.${child.key}`)
        : t(`header_actions.${child.props.children}`),
    });
  });

  return (
    <Menu>
      <MenuButton component={Button} variant='primary'>
        {t('actions')} <Chevrondown className={styles.actionIcon} />
      </MenuButton>
      <MenuList className='fw-bold bg-lightblue color-blue'>{translatedActionsList}</MenuList>
    </Menu>
  );
}
